module.exports = __webpack_public_path__ + "img/cx.aa81bb9e.svg";